export default "__VITE_ASSET__BhjUROrP__"